/**
 * CommunityHub.jsx — Onglet "Communauté" natif fusionnant Coaching (hub visio/checkin/onboarding),
 * Messagerie coach et Chat Communauté sous un seul segmented control (façon app native).
 */
import React, { useState, useEffect } from 'react';
import { Dumbbell, Users, MessageCircle } from 'lucide-react';
import { CoachingHub } from './CoachingHub';
import CommunityChat from './CommunityChat';
import { MessagingPanel } from './MessagingPanel';

const SEGMENTS = [
  { key: 'coaching', icon: Dumbbell, fr: 'Coaching', en: 'Coaching' },
  { key: 'community', icon: Users, fr: 'Communauté', en: 'Community' },
  { key: 'coach', icon: MessageCircle, fr: 'Coach', en: 'Coach' },
];

export const CommunityHub = ({ en, onNavigate, initialView, onConsumeInitialView }) => {
  const L = (fr, eng) => (en ? eng : fr);
  const [view, setView] = useState('coaching');

  useEffect(() => {
    if (initialView) {
      setView(initialView);
      onConsumeInitialView && onConsumeInitialView();
    }
  }, [initialView]);

  const handleCoachingNavigate = (key, payload) => {
    if (key === 'social') { setView(payload || 'coach'); return; }
    onNavigate && onNavigate(key, payload);
  };

  return (
    <div className="space-y-4" data-testid="community-hub">
      <div className="flex gap-1 sm:gap-1.5 p-1.5 bg-white/[0.035] backdrop-blur-xl border border-white/10 shadow-[0_0_30px_-12px_rgba(217,70,239,0.25)] rounded-2xl w-full sm:w-fit">
        {SEGMENTS.map((s) => (
          <button
            key={s.key}
            onClick={() => setView(s.key)}
            className={`flex-1 sm:flex-none min-w-0 inline-flex items-center justify-center gap-1.5 sm:gap-2 px-2 sm:px-4 py-2.5 rounded-xl text-xs sm:text-sm font-bold transition-all truncate ${
              view === s.key ? 'bg-gradient-to-r from-primary to-pink-500 text-white' : 'text-zinc-400 hover:text-white'
            }`}
            data-testid={`community-segment-${s.key}`}
          >
            <s.icon className="w-4 h-4 shrink-0" /> <span className="truncate">{L(s.fr, s.en)}</span>
          </button>
        ))}
      </div>

      {view === 'coaching' ? (
        <CoachingHub en={en} onNavigate={handleCoachingNavigate} />
      ) : view === 'community' ? (
        <CommunityChat en={en} />
      ) : (
        <MessagingPanel en={en} />
      )}
    </div>
  );
};

export default CommunityHub;
